export function validateTel(tel) {
  const re = /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/;
  if (re.test(tel)) {
    return true;
  }
  return false;
  //return re.test(tel);
}
